export {
	default,
	type IconColor,
	type IconDirection,
	type IconName,
	type IconSize,
} from './Icon';
